<template>
  <div class="col-12">
    <b-row>
      <b-col cols="12">
        <Search
          v-if="url"
          :allowFields="$lang.searchResearchSeniorMaster"
          :allowCollapse="false"
          :url="url"
          :title="$lang.interview_senior_master"
          config="address"
          addModalSize="lg"
          removeModalSize="xl"
          :visibleSearch="false"
          :visibleSettings="false"
          :visibleExport="false"
          :visibleFilters="false"
          :visibleViewCount="false"
          :allowEdit="false"
          :visibleAccordion="true"
          ref="searchResearchSeniorMaster"
          :dynamicButtons="buttonsAddress"
          :colorTable="true"
          :changeColorTable="changeColorTable"
          :parentPermissions="parentPermissions"
          :itemTopHeader="itemTopHeader"
        >
          <template slot="addModal" slot-scope="search">
            <AddInterviewSeniorMaster @modal-end-up="search.close" />
          </template>
        </Search>

        <b-modal
          no-close-on-backdrop
          variant="primary"
          header-bg-variant="primary"
          content-class="border-primary"
          v-model="view_edit"
          size="xl"
          ok-only
          hide-footer
          hide-header
        >
          <AcceptMaster :code="code" @cancel="cancel" />
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddInterviewSeniorMaster from "./addInterviewSeniorMaster";
import AcceptMaster from "./acceptMaster";

export default {
  inject: ["interviewRepository"],
  components: {
    Search,
    AddInterviewSeniorMaster,
    AcceptMaster,
  },
  props: {
    parentPermissions: {
      type: Array,
    },
  },
  data() {
    return {
      buttonsAddress: [
        {
          id: 0,
          name: "acceptMaster",
          click: this.editSearch,
        },
        {
          id: "1",
          name: "view",
          click: this.editSearch,
        },
        {
          id: "3",
          name: "delete",
        },
      ],
      itemTopHeader: [
        {
          colspan: 5,
          name: this.$lang.interview_senior,
        },
        {
          colspan: 4,
          name: this.$lang.interview_master,
          variant: "info",
        },
      ],
      code: null,
      person_code: this.$route.params.code,
      view_edit: false,
      url: this.$config.api_url + this.$config.interview.base,
    };
  },
  methods: {
    cancel() {
      this.view_edit = false;
    },
    changeColorTable(allowFields) {
      return Object.keys(allowFields).map((item, i) => {
        return {
          label: allowFields[item],
          key: item,
          sortable: true,
          variant: i > 3 ? "info" : "",
        };
      });
    },
    editSearch(item) {
      this.code = item.master && item.master.code;
      this.view_edit = true;
    },
    closeEditAddress() {
      this.view_edit = false;
      this.$refs.searchAddress.getItems();
      this.code = null;
    },
  },
};
</script>
